<div class="dc-wizard" *ngIf="!loading && check">
    <div class="dc-wizard-header">
        <button type="button" class="dc-back-arrow" (click)="salirAlListado()"><img src="assets/img/departure-check/icon-back-arrow.svg" alt="Salir al listado"></button>
        <p class="dc-title">Check de salida</p>
    </div>

    <div class="dc-stepper">
        <ng-container *ngFor="let label of stepLabels; let i = index">
            <div class="dc-step" [ngClass]="'dc-step--' + stepStatus(i)">
                <div class="dc-step-circle">
                    <img src="assets/img/departure-check/icon-step-check.svg" alt="" *ngIf="stepStatus(i) === 'done'">
                    <span *ngIf="stepStatus(i) !== 'done'">{{i + 1}}</span>
                </div>
                <p class="dc-step-label">{{label}}</p>
            </div>
            <div class="dc-step-line" [class.dc-step-line--done]="i + 1 < step" *ngIf="i < stepLabels.length - 1"></div>
        </ng-container>
    </div>

    <!-- Paso 1: Servicio -->
    <div class="dc-card" *ngIf="step === 1">
        <p class="dc-section-title">Datos del servicio</p>
        <p class="dc-section-subtitle">Rectifica con el Operador los datos del servicio al cual fue asignado</p>

        <div class="dc-service-box">
            <div class="dc-service-row">
                <div class="dc-field"><p class="dc-field-label">Folio</p><p class="dc-field-value">#{{check.service.folio}}</p></div>
                <div class="dc-field"><p class="dc-field-label">Salida programada</p><p class="dc-field-value">{{check.service.departure_date}} - {{check.service.departure_time}}</p></div>
            </div>
            <div class="dc-service-divider"></div>

            <div class="dc-service-row">
                <div class="dc-field"><p class="dc-field-label">Operador</p><p class="dc-field-value">{{check.service.driver_name}}</p></div>
                <button type="button" class="dc-verify-check" [class.dc-verify-check--on]="verifiedFields['operador']" (click)="toggleVerified('operador')">
                    <img *ngIf="verifiedFields['operador']" src="assets/img/departure-check/icon-checkbox-checked.svg" alt="">
                </button>
                <div class="dc-field"><p class="dc-field-label">Auxiliar</p><p class="dc-field-value">{{check.service.assistant_name || '--'}}</p></div>
                <button type="button" class="dc-verify-check" [class.dc-verify-check--on]="verifiedFields['auxiliar']" (click)="toggleVerified('auxiliar')">
                    <img *ngIf="verifiedFields['auxiliar']" src="assets/img/departure-check/icon-checkbox-checked.svg" alt="">
                </button>
            </div>
            <div class="dc-service-divider"></div>

            <div class="dc-service-row">
                <div class="dc-field"><p class="dc-field-label">Origen</p><p class="dc-field-value">{{check.service.origin_address}}</p></div>
                <div class="dc-field"><p class="dc-field-label">Destino</p><p class="dc-field-value">{{check.service.destination_address}}</p></div>
            </div>
            <div class="dc-service-divider"></div>

            <div class="dc-service-row">
                <div class="dc-field"><p class="dc-field-label">Unidad</p><p class="dc-field-value">{{check.service.unit}}<span *ngIf="check.service.unit_configuration"> ({{check.service.unit_configuration}})</span></p></div>
                <button type="button" class="dc-verify-check" [class.dc-verify-check--on]="verifiedFields['unidad']" (click)="toggleVerified('unidad')">
                    <img *ngIf="verifiedFields['unidad']" src="assets/img/departure-check/icon-checkbox-checked.svg" alt="">
                </button>
                <div class="dc-field"><p class="dc-field-label">Placa</p><p class="dc-field-value">{{check.service.plates}}</p></div>
                <button type="button" class="dc-verify-check" [class.dc-verify-check--on]="verifiedFields['placa']" (click)="toggleVerified('placa')">
                    <img *ngIf="verifiedFields['placa']" src="assets/img/departure-check/icon-checkbox-checked.svg" alt="">
                </button>
            </div>
            <div class="dc-service-divider"></div>

            <div class="dc-equipment">
                <p class="dc-field-label">Equipo de seguridad</p>
                <div class="dc-equipment-row">
                    <div class="dc-equipment-list">
                        <span>&bull; Bandas<br><strong>Cantidad: {{check.service.safety_equipment.bands || 0}}</strong></span>
                        <span>&bull; Patines<br><strong>Cantidad: {{check.service.safety_equipment.roller_skates || 0}}</strong></span>
                        <span>&bull; Diablos<br><strong>Cantidad: {{check.service.safety_equipment.devils || 0}}</strong></span>
                        <span>&bull; Colchonetas<br><strong>Cantidad: {{check.service.safety_equipment.mats || 0}}</strong></span>
                        <span>&bull; Playos<br><strong>Cantidad: {{check.service.safety_equipment.beach || 0}}</strong></span>
                        <span>&bull; Cartones<br><strong>Cantidad: {{check.service.safety_equipment.cartons || 0}}</strong></span>
                    </div>
                    <button type="button" class="dc-verify-check" [class.dc-verify-check--on]="verifiedFields['equipo']" (click)="toggleVerified('equipo')">
                        <img *ngIf="verifiedFields['equipo']" src="assets/img/departure-check/icon-checkbox-checked.svg" alt="">
                    </button>
                </div>
            </div>
            <div class="dc-service-divider"></div>

            <div class="dc-observacion-card">
                <p class="dc-observacion-title">Observaciónes</p>
                <textarea [(ngModel)]="serviceObservations" placeholder="Ingresar"></textarea>
            </div>
        </div>

        <div class="dc-footer">
            <button type="button" class="dc-btn dc-btn-outline" (click)="cancelar()">Cancelar check</button>
            <button type="button" class="dc-btn dc-btn-primary" [disabled]="saving" (click)="continuarServicio()">Continuar <img src="assets/img/departure-check/icon-chevron-right.svg" alt=""></button>
        </div>
    </div>

    <!-- Paso 2: Unidad -->
    <div class="dc-card" *ngIf="step === 2">
        <p class="dc-section-title">Estado exterior de la unidad</p>
        <p class="dc-section-subtitle">Selecciona en el vehículo las áreas con algún daño visible.</p>

        <div class="dc-diagram-box">
            <app-vehicle-damage-diagram [points]="damagePoints" [unitName]="check?.service?.unit" (pointsChange)="onDamagePointsChange($event)"></app-vehicle-damage-diagram>

            <div class="dc-observaciones">
                <p class="dc-field-label">Observaciónes</p>
                <textarea placeholder="Ingresar" [(ngModel)]="damageObservations"></textarea>
            </div>
        </div>

        <div class="dc-footer">
            <button type="button" class="dc-btn dc-btn-outline" (click)="regresar()">Regresar</button>
            <button type="button" class="dc-btn dc-btn-primary" [disabled]="saving" (click)="continuarDamage()">Continuar <img src="assets/img/departure-check/icon-chevron-right.svg" alt=""></button>
        </div>
    </div>

    <!-- Paso 3: Funcionamiento -->
    <div class="dc-card" *ngIf="step === 3">
        <ng-container *ngIf="funcionamientoSubStep === 'list'">
            <p class="dc-section-title">Funcionamiento</p>
            <p class="dc-section-subtitle">Verifica el funcionamiento de los siguientes elementos.</p>

            <div class="dc-funcionamiento-box">
                <button type="button" class="dc-funcionamiento-row" *ngFor="let item of funcionamiento" (click)="abrirDetalleFuncionamiento(item)">
                    <img class="dc-funcionamiento-icon" [src]="'assets/img/departure-check/' + item.icon" alt="">
                    <span class="dc-funcionamiento-label">{{item.label}}</span>
                    <img class="dc-funcionamiento-check" src="assets/img/departure-check/icon-check-badge.svg" alt="" *ngIf="item.ok !== null">
                    <img class="dc-funcionamiento-chevron" src="assets/img/departure-check/icon-row-arrow.svg" alt="">
                </button>
            </div>

            <div class="dc-footer">
                <button type="button" class="dc-btn dc-btn-outline" (click)="regresar()">Regresar</button>
                <button type="button" class="dc-btn dc-btn-primary" [disabled]="saving" (click)="continuarFuncionamiento()">Continuar <img src="assets/img/departure-check/icon-chevron-right.svg" alt=""></button>
            </div>
        </ng-container>

        <!-- Detalle: ¿Que anomalia presenta? -->
        <div class="dc-anomaly-box" *ngIf="funcionamientoSubStep === 'detail' && selectedFuncionamientoItem as item">
            <button type="button" class="dc-anomaly-back" (click)="cerrarDetalleFuncionamiento()">
                <img src="assets/img/departure-check/icon-chevron-left.svg" alt="" class="dc-anomaly-back-icon">
                <span>¿Que anomalía presenta?</span>
            </button>
            <p class="dc-anomaly-selected">
                Elemento seleccionado:
                <img [src]="'assets/img/departure-check/' + item.icon" alt="">
                <span>{{item.label}}</span>
            </p>

            <p class="dc-anomaly-hint">Selecciona la anomalía</p>
            <div class="dc-anomaly-options">
                <label class="dc-anomaly-option" *ngFor="let option of anomalyOptionsFor(item)">
                    <input type="checkbox" [checked]="isAnomalySelected(item.key, option)" (change)="toggleAnomalyOption(item.key, option)">
                    <span>{{option}}</span>
                </label>
            </div>

            <div class="dc-observaciones">
                <p class="dc-field-label">Observaciónes</p>
                <textarea placeholder="Ingresar" [(ngModel)]="detailAnomalyNote"></textarea>
            </div>

            <div class="dc-anomaly-footer">
                <button type="button" class="dc-btn dc-btn-outline" (click)="registrarAnomalia()">
                    Registrar anomalía <img src="assets/img/departure-check/icon-save.svg" alt="">
                </button>
            </div>
        </div>
    </div>

    <!-- Paso 4: Tablero -->
    <div class="dc-card" *ngIf="step === 4">
        <p class="dc-section-title">Tablero</p>
        <p class="dc-section-subtitle">Ingresa el nivel de combustible y el funcionamiento del tablero de la unidad</p>

        <div class="dc-tablero-box">
            <p class="dc-field-label-lg">Kilometraje actual</p>
            <input type="number" class="dc-input" [(ngModel)]="mileage" placeholder="0 km">

            <p class="dc-field-label-fuel dc-mt">Nivel de combustible</p>
            <div class="dc-fuel-gauge">
                <div class="dc-fuel-dial-wrap">
                    <img class="dc-fuel-dial-bg" src="assets/img/departure-check/fuel-gauge-bg.svg" alt="">
                    <svg class="dc-fuel-needle-svg" viewBox="0 0 227 129">
                        <line class="dc-fuel-needle" x1="114" y1="128" x2="114" y2="15"
                            [attr.transform]="'rotate(' + needleAngle + ' 114 128)'"></line>
                        <circle cx="114" cy="128" r="7" fill="#00a0e1"></circle>
                    </svg>
                </div>
                <input type="range" class="dc-fuel-slider" min="0" max="100" [(ngModel)]="fuelLevel"
                    [style.background]="'linear-gradient(to right, #00a0e1 ' + fuelLevel + '%, #d9d9d9 ' + fuelLevel + '%)'">
            </div>

            <p class="dc-field-label-lg dc-mt">Fotografía del odómetro</p>
            <div class="dc-odometer-photo">
                <img *ngIf="odometerPhotoPreview" [src]="odometerPhotoPreview" alt="Odómetro">
                <div class="dc-odometer-empty" *ngIf="!odometerPhotoPreview">
                    <img src="assets/img/departure-check/icon-camera-circle.svg" alt="">
                </div>
            </div>
            <div class="dc-upload-btn-row">
                <label class="dc-btn dc-btn-outline dc-upload-btn">
                    <img src="assets/img/departure-check/icon-camera.svg" alt=""> {{ odometerPhotoPreview ? 'Reemplazar foto' : 'Tomar foto' }}
                    <input type="file" accept="image/*" (change)="onOdometerPhotoSelected($event)" hidden>
                </label>
            </div>

            <p class="dc-field-label-lg dc-mt" style="color:#3c3c3b">Sensores del tablero</p>
            <div class="dc-sensors-wrap">
                <div class="dc-sensors-row">
                    <button type="button" class="dc-sensor" *ngFor="let s of sensoresRow1" [class.dc-sensor--active]="s.active" (click)="toggleSensor(s)" [attr.title]="s.label">
                        <img *ngIf="!s.active" [src]="'assets/img/departure-check/' + s.icon" [style.width.px]="s.w" [style.height.px]="s.h" alt="">
                        <div *ngIf="s.active" class="dc-sensor-icon-active" [style.width.px]="s.w" [style.height.px]="s.h"
                            [ngStyle]="{'-webkit-mask-image': 'url(assets/img/departure-check/' + s.icon + ')', 'mask-image': 'url(assets/img/departure-check/' + s.icon + ')'}"></div>
                    </button>
                </div>
                <div class="dc-sensors-row dc-sensors-row--compact">
                    <button type="button" class="dc-sensor" *ngFor="let s of sensoresRow2" [class.dc-sensor--active]="s.active" (click)="toggleSensor(s)" [attr.title]="s.label">
                        <img *ngIf="!s.active" [src]="'assets/img/departure-check/' + s.icon" [style.width.px]="s.w" [style.height.px]="s.h" alt="">
                        <div *ngIf="s.active" class="dc-sensor-icon-active" [style.width.px]="s.w" [style.height.px]="s.h"
                            [ngStyle]="{'-webkit-mask-image': 'url(assets/img/departure-check/' + s.icon + ')', 'mask-image': 'url(assets/img/departure-check/' + s.icon + ')'}"></div>
                    </button>
                </div>
            </div>

            <p class="dc-field-label dc-mt">Observaciónes</p>
            <textarea placeholder="Ingresar" [(ngModel)]="tableroObservations"></textarea>
        </div>

        <div class="dc-footer">
            <button type="button" class="dc-btn dc-btn-outline" (click)="regresar()">Regresar</button>
            <button type="button" class="dc-btn dc-btn-primary" [disabled]="saving" (click)="continuarTablero()">Continuar <img src="assets/img/departure-check/icon-chevron-right.svg" alt=""></button>
        </div>
    </div>

    <!-- Paso 5: Fotos -->
    <div class="dc-card" *ngIf="step === 5">
        <p class="dc-section-title">Evidencia fotográfica</p>
        <p class="dc-section-subtitle">Captura las fotografías solicitadas.</p>

        <div class="dc-fotos-grid">
            <div class="dc-foto-card" *ngFor="let cat of fotoCategorias">
                <div class="dc-foto-card-header">
                    <span>{{cat.label}}</span>
                    <span class="dc-foto-check-badge" *ngIf="fotoPreviews[cat.key]"><img src="assets/img/departure-check/icon-check-badge.svg" alt=""></span>
                </div>
                <label class="dc-foto-body" [class.dc-foto-body--add]="!fotoPreviews[cat.key]">
                    <img *ngIf="fotoPreviews[cat.key]" [src]="fotoPreviews[cat.key]" [alt]="cat.label">
                    <div class="dc-foto-placeholder" *ngIf="!fotoPreviews[cat.key]">
                        <span class="dc-foto-placeholder-circle"><img src="assets/img/departure-check/icon-camera-circle.svg" alt=""></span>
                        <span>Tomar foto</span>
                    </div>
                    <input type="file" accept="image/*" (change)="onFotoSelected($event, cat.key)" hidden>
                </label>
            </div>

            <!-- Odometro: ya se capturo en el paso 4 (Tablero), aqui solo se muestra como evidencia. -->
            <div class="dc-foto-card">
                <div class="dc-foto-card-header">
                    <span>Odómetro</span>
                    <span class="dc-foto-check-badge" *ngIf="odometerPhotoPreview"><img src="assets/img/departure-check/icon-check-badge.svg" alt=""></span>
                </div>
                <label class="dc-foto-body" [class.dc-foto-body--add]="!odometerPhotoPreview">
                    <img *ngIf="odometerPhotoPreview" [src]="odometerPhotoPreview" alt="Odómetro">
                    <div class="dc-foto-placeholder" *ngIf="!odometerPhotoPreview">
                        <span class="dc-foto-placeholder-circle"><img src="assets/img/departure-check/icon-camera-circle.svg" alt=""></span>
                        <span>Tomar foto</span>
                    </div>
                    <input type="file" accept="image/*" (change)="onOdometerPhotoSelected($event)" hidden>
                </label>
            </div>

            <!-- Tablero: foto opcional (testigos/anomalias del tablero), no bloquea "Continuar". -->
            <div class="dc-foto-card">
                <div class="dc-foto-card-header">
                    <span>Tablero (si aplica)</span>
                    <span class="dc-foto-check-badge" *ngIf="fotoPreviews['tablero']"><img src="assets/img/departure-check/icon-check-badge.svg" alt=""></span>
                </div>
                <label class="dc-foto-body" [class.dc-foto-body--add]="!fotoPreviews['tablero']">
                    <img *ngIf="fotoPreviews['tablero']" [src]="fotoPreviews['tablero']" alt="Tablero">
                    <div class="dc-foto-placeholder" *ngIf="!fotoPreviews['tablero']">
                        <span class="dc-foto-placeholder-circle"><img src="assets/img/departure-check/icon-camera-circle.svg" alt=""></span>
                        <span>Tomar foto</span>
                    </div>
                    <input type="file" accept="image/*" (change)="onFotoSelected($event, 'tablero')" hidden>
                </label>
            </div>

            <!-- Danos registrados: foto adicional como evidencia de los danos marcados en el paso 2. -->
            <div class="dc-foto-card">
                <div class="dc-foto-card-header">
                    <span>Daños registrados</span>
                    <span class="dc-foto-check-badge" *ngIf="fotoPreviews['danos']"><img src="assets/img/departure-check/icon-check-badge.svg" alt=""></span>
                </div>
                <label class="dc-foto-body" [class.dc-foto-body--add]="!fotoPreviews['danos']">
                    <img *ngIf="fotoPreviews['danos']" [src]="fotoPreviews['danos']" alt="Daños registrados">
                    <div class="dc-foto-placeholder" *ngIf="!fotoPreviews['danos']">
                        <span class="dc-foto-placeholder-circle"><img src="assets/img/departure-check/icon-camera-circle.svg" alt=""></span>
                        <span>Tomar foto</span>
                    </div>
                    <input type="file" accept="image/*" (change)="onFotoSelected($event, 'danos')" hidden>
                </label>
            </div>

            <div class="dc-foto-card dc-foto-card--add">
                <div class="dc-foto-card-header"><span>Agregar foto adicional</span></div>
                <label class="dc-foto-body dc-foto-body--add">
                    <div class="dc-foto-placeholder">
                        <span class="dc-foto-placeholder-circle"><img src="assets/img/departure-check/icon-camera-circle.svg" alt=""></span>
                        <span>Agregar foto adicional<br>(opcional)</span>
                    </div>
                    <input type="file" accept="image/*" (change)="onFotoSelected($event, 'adicional')" hidden>
                </label>
            </div>
        </div>

        <div class="dc-footer">
            <button type="button" class="dc-btn dc-btn-outline" (click)="regresar()">Regresar</button>
            <button type="button" class="dc-btn dc-btn-primary" [disabled]="saving" (click)="continuarFotos()">Continuar <img src="assets/img/departure-check/icon-chevron-right.svg" alt=""></button>
        </div>
    </div>

    <!-- Paso 6: Documentos -->
    <div class="dc-card" *ngIf="step === 6">
        <p class="dc-section-title">Documentación</p>
        <p class="dc-section-subtitle">Valida que la documentación se encuentre vigente y completa</p>

        <div class="dc-documentos-box">
            <div class="dc-documento-row" *ngFor="let doc of documentos">
                <div class="dc-documento-icon" [ngClass]="doc.boxClass"><img [src]="'assets/img/departure-check/' + doc.icon" alt=""></div>
                <div class="dc-documento-text">
                    <p class="dc-documento-label">{{doc.label}}</p>
                    <p class="dc-documento-subtitle">{{doc.subtitle}}</p>
                </div>
                <input type="checkbox" class="dc-doc-checkbox" [(ngModel)]="doc.verified">
            </div>

            <p class="dc-field-label dc-mt">Observaciónes</p>
            <textarea placeholder="Ingresar" [(ngModel)]="documentosObservations"></textarea>
        </div>

        <div class="dc-footer">
            <button type="button" class="dc-btn dc-btn-outline" (click)="regresar()">Regresar</button>
            <button type="button" class="dc-btn dc-btn-primary" [disabled]="saving" (click)="continuarDocumentos()">Continuar <img src="assets/img/departure-check/icon-chevron-right.svg" alt=""></button>
        </div>
    </div>

    <!-- Paso 7: Resumen -->
    <div class="dc-card" *ngIf="step === 7">
        <p class="dc-section-title">Resumen del check de salida</p>
        <p class="dc-section-subtitle">Revisa el resumen antes de liberar la unidad</p>

        <div class="dc-resumen-box">
            <div class="dc-resumen-row"><span>Datos del servicio</span><strong class="dc-ok">{{resumenServicio}}</strong></div>
            <div class="dc-resumen-row"><span>Estado de la unidad</span><strong [class.dc-ok]="damagePoints.length === 0" [class.dc-warn]="damagePoints.length > 0">{{resumenUnidad}}</strong></div>
            <div class="dc-resumen-row"><span>Funcionamiento</span><strong [class.dc-ok]="funcionamientoCompletos === funcionamiento.length" [class.dc-warn]="funcionamientoCompletos < funcionamiento.length">{{resumenFuncionamiento}}</strong></div>
            <div class="dc-resumen-row"><span>Sensores del tablero</span><strong [class.dc-ok]="resumenSensores === 'Sin alertas'" [class.dc-warn]="resumenSensores !== 'Sin alertas'">{{resumenSensores}}</strong></div>
            <div class="dc-resumen-row"><span>Evidencia fotográfica</span><strong class="dc-ok">{{resumenFotos}}</strong></div>
            <div class="dc-resumen-row"><span>Documentación</span><strong [class.dc-ok]="resumenDocumentos === 'Completa'" [class.dc-warn]="resumenDocumentos !== 'Completa'">{{resumenDocumentos}}</strong></div>
        </div>

        <div class="dc-observaciones-card dc-mt">
            <p class="dc-observaciones-title">Observaciónes generales</p>
            <textarea placeholder="Ingresar" [(ngModel)]="generalObservations"></textarea>
        </div>

        <div class="dc-resultado-banner" [class.dc-resultado-banner--warn]="!unidadApta">
            <img *ngIf="unidadApta" class="dc-resultado-icon-ok" src="assets/img/departure-check/icon-result-check.svg" alt="">
            <div *ngIf="!unidadApta" class="dc-resultado-icon-warn">
                <img src="assets/img/departure-check/icon-alert-triangle-white.svg" alt="">
            </div>
            <div>
                <p class="dc-resultado-label">RESULTADO</p>
                <p class="dc-resultado-value">{{unidadApta ? 'UNIDAD APTA PARA SALIDA' : 'SE REQUIERE CAMBIO EN EL SERVICIO PARA LIBERAR LA UNIDAD'}}</p>
            </div>
        </div>

        <div class="dc-confirm-box" *ngIf="!unidadApta">
            <p class="dc-confirm-question">¿La unidad se encuentra en óptimas condiciones para realizar el servicio?</p>
            <div class="dc-confirm-options">
                <button type="button" class="dc-confirm-option" (click)="unidadAptaConfirmation = true">
                    <img *ngIf="unidadAptaConfirmation === true" src="assets/img/departure-check/icon-check-square-blue.svg" alt="">
                    <span *ngIf="unidadAptaConfirmation !== true" class="dc-check-square-empty"></span>
                    <span>Si</span>
                </button>
                <button type="button" class="dc-confirm-option" (click)="unidadAptaConfirmation = false">
                    <img *ngIf="unidadAptaConfirmation === false" src="assets/img/departure-check/icon-check-square-blue.svg" alt="">
                    <span *ngIf="unidadAptaConfirmation !== false" class="dc-check-square-empty"></span>
                    <span>No</span>
                </button>
            </div>
        </div>

        <div class="dc-footer">
            <button type="button" class="dc-btn dc-btn-outline" (click)="regresar()">Regresar</button>
            <button *ngIf="unidadApta || unidadAptaConfirmation === true" type="button" class="dc-btn dc-btn-liberar" [disabled]="saving" (click)="liberarUnidad()">Liberar unidad</button>
            <button *ngIf="!unidadApta && unidadAptaConfirmation === false" type="button" class="dc-btn dc-btn-solicitar" [disabled]="saving" (click)="solicitarActualizacion()">Solicitar actualización del servicio</button>
        </div>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
